// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");

function resultTypeToJs(param) {
  return param + 0 | 0;
}

function resultTypeFromJs(param) {
  if (param <= 9 && 0 <= param) {
    return param - 0 | 0;
  }
  
}

var External = {};

var IteratorResult = {};

function snapshotItem(result, index) {
  return Caml_option.nullable_to_opt(result.ext.snapshotItem(index));
}

var SnapshotResult = {
  snapshotItem: snapshotItem
};

function classify(v) {
  var match = resultTypeFromJs(v.resultType);
  if (match === undefined) {
    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected resultType: " + String(v.resultType));
  }
  switch (match) {
    case /* ANY_TYPE */0 :
        return {
                TAG: /* AnyResult */0,
                _0: v
              };
    case /* NUMBER_TYPE */1 :
        return {
                TAG: /* NumberResult */2,
                _0: v.numberValue
              };
    case /* STRING_TYPE */2 :
        return {
                TAG: /* StringResult */3,
                _0: v.stringValue
              };
    case /* BOOLEAN_TYPE */3 :
        return {
                TAG: /* BooleanResult */1,
                _0: v.booleanValue
              };
    case /* UNORDERED_NODE_ITERATOR_TYPE */4 :
        return {
                TAG: /* UnorderedNodeIteratorResult */4,
                _0: {
                  invalidIteratorState: v.invalidIteratorState,
                  ext: v
                }
              };
    case /* ORDERED_NODE_ITERATOR_TYPE */5 :
        return {
                TAG: /* OrderedNodeIteratorResult */5,
                _0: {
                  invalidIteratorState: v.invalidIteratorState,
                  ext: v
                }
              };
    case /* UNORDERED_NODE_SNAPSHOT_TYPE */6 :
        return {
                TAG: /* UnorderedNodeSnapshotResult */6,
                _0: {
                  snapshotLength: v.snapshotLength,
                  ext: v
                }
              };
    case /* ORDERED_NODE_SNAPSHOT_TYPE */7 :
        return {
                TAG: /* OrderedNodeSnapshotResult */7,
                _0: {
                  snapshotLength: v.snapshotLength,
                  ext: v
                }
              };
    case /* ANY_UNORDERED_NODE_TYPE */8 :
        return {
                TAG: /* AnyUnorderedNodeResult */8,
                _0: {
                  invalidIteratorState: v.invalidIteratorState,
                  ext: v
                }
              };
    case /* FIRST_ORDERED_NODE_TYPE */9 :
        return {
                TAG: /* FirstOrderedNodeResult */9,
                _0: {
                  invalidIteratorState: v.invalidIteratorState,
                  ext: v
                }
              };
    
  }
}

var Result = {
  resultTypeToJs: resultTypeToJs,
  resultTypeFromJs: resultTypeFromJs,
  External: External,
  IteratorResult: IteratorResult,
  SnapshotResult: SnapshotResult,
  classify: classify
};

var Expression = {};

var Evaluator = {};

function normalizeSpace(builder) {
  return "normalize-space(" + (builder + ")");
}

function translate(from, to_, builder) {
  return "translate(" + (builder + (", " + (StringUtils$SmartcutsMacros.quote(StringUtils$SmartcutsMacros.escapeQuotes(from)) + (", " + (StringUtils$SmartcutsMacros.quote(StringUtils$SmartcutsMacros.escapeQuotes(to_)) + ")")))));
}

function lowercase(param) {
  return translate("ABCDEFGHIJKLMNOPQRSTUVWXYZ", "abcdefghijklmnopqrstuvwxyz", param);
}

function equals(value, builder) {
  return builder + ("=" + StringUtils$SmartcutsMacros.quote(StringUtils$SmartcutsMacros.escapeQuotes(value)));
}

function contains(value, builder) {
  return "contains(" + (builder + (", " + (StringUtils$SmartcutsMacros.quote(StringUtils$SmartcutsMacros.escapeQuotes(value)) + ")")));
}

function elementWithOrDescendantElementsWith(builder) {
  return "(.//*|.)[" + (builder + "]");
}

var ExpressionBuilder = {
  text: "text()",
  dot: ".",
  normalizeSpace: normalizeSpace,
  translate: translate,
  lowercase: lowercase,
  equals: equals,
  contains: contains,
  elementWithOrDescendantElementsWith: elementWithOrDescendantElementsWith
};

exports.Result = Result;
exports.Expression = Expression;
exports.Evaluator = Evaluator;
exports.ExpressionBuilder = ExpressionBuilder;
/* Util-SmartcutsMacros Not a pure module */
